/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ChargeType = "dynamic" | "static" | "%future added value";
export type UpdateCharge_charge = {
    readonly id: string;
    readonly chargeType: ChargeType;
    readonly name: string;
    readonly description: string;
    readonly chargeIdentifier: string;
    readonly prices: ReadonlyArray<{
        readonly amount: number;
        readonly currency: string;
    }>;
    readonly metricName: string | null;
    readonly " $refType": "UpdateCharge_charge";
};
export type UpdateCharge_charge$data = UpdateCharge_charge;
export type UpdateCharge_charge$key = {
    readonly " $data"?: UpdateCharge_charge$data;
    readonly " $fragmentRefs": FragmentRefs<"UpdateCharge_charge">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateCharge_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chargeIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "prices",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricName",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
(node as any).hash = '844205ee892fde52aa58782d49b7daa6';
export default node;
